import isJson from '@/helpers/isJson'

export const propertiesTemplates = {
    baseColor: [
        {
            label: 'צבע בסיס',
            key: 'baseColor',
        },
        {
            label: 'צבע סקין',
            key: 'skinColor',
        },
        {
            label: 'צבע גוונים',
            key: 'highlightsColoringSelect',
        },
        {
            label: 'צבע גוונים',
            key: 'highlightsColoring',
        },
        {
            label: 'סוג גוונים',
            key: 'typeOfHighlights',
        },
        {
            label: 'גוונים בסקין',
            key: 'skinTopHighlights',
        },
        {
            label: 'צבע פרונט',
            key: 'frontColor',
        },
        {
            label: 'עם גוונים',
            key: 'withHighlights',
        },
        {
            label: 'צבע גוונים',
            key: 'highlightsColor',
        },
        {
            label: 'צבע גוונים',
            key: 'highlightsColorSelect',
        },
        {
            label: 'הערות צבע',
            key: 'colorComments',
        },
    ],
    length: [
        {
            label: 'אורך',
            key: 'length',
        },
        {
            label: 'אורך מהעורף',
            key: 'lengthFromNape',
        },
        {
            label: 'אורך מהכיפה',
            key: 'lengthFromTop',
        },
        {
            label: 'אורך בצדדים',
            key: 'sideLength',
        },
        {
            label: 'הערות לאורך',
            key: 'lengthComments',
        },
    ],
    heirTexture: [
        {
            label: 'סוג שיער טרסים',
            key: 'hairTextureOnWefts',
        },
        {
            label: 'הערות סוג שיער',
            key: 'hairTextureComments',
        },
    ],
    wigFullness: [
        {
            label: 'מלאות הפאה',
            key: 'wigFullness',
        },
        {
            label: 'תוספת סך',
            key: 'wigFullnessAdditionalAmount',
        },
        {
            label: 'הערות למלאות הפאה',
            key: 'wigFullnessComments',
        },
    ],
    front: [
        {
            label: 'לייס סגור',
            key: 'Closed Lace',
        },
        {
            label: 'לייס פתוח',
            key: 'Open Lace',
        },
        {
            label: 'עבודת יד',
            key: 'Hand Tie',
        },
        {
            label: 'הערות לפרונט',
            key: 'frontComments',
        },
    ],
    capSize: [
        {
            label: 'גודל רשת',
            key: 'capSize',
        },
        {
            label: 'התאמת רשת',
            key: 'capAdjustment',
        },
    ],
    topTape: [
        {
            label: 'סקין רגיל',
            key: 'Regular Skin',
        },
        {
            label: 'סקין רגיל',
            key: 'Regular Skin Alt',
        },
        {
            label: 'לייס טופ',
            key: 'Lace Top',
        },
        {
            label: 'ריבן',
            key: 'Ribben',
        },
        {
            label: 'טופ כשר',
            key: 'Kosher Top',
        },
        {
            label: 'סוג סקין',
            key: 'Skin Type',
        },
        {
            label: 'ריבן',
            key: 'Ribben Alt',
        },
        {
            label: 'שבלול',
            key: 'Weft Top In Circle',
        },
        {
            label: 'גובה הסקין',
            key: 'Skin Heights',
        },
        {
            label: 'הערות סוג כיפה',
            key: 'topTypeComments',
        },
    ],
}

const processKeys = (parsedKey, res) => {
    parsedKey.forEach((key) => {
        let [arrSubKey, arrValue] = key

        if (Object.hasOwn(res, arrSubKey)) {
            arrSubKey += ' Alt'
        }

        res = { ...res, [arrSubKey]: arrValue }
    })

    return res
}

export const provideTopTapeProperty = (wigProperties) => {
    let res = wigProperties

    Object.keys(wigProperties).forEach((key) => {
        if (!isJson(wigProperties[key])) return

        const parsedKey = JSON.parse(wigProperties[key])

        if (Array.isArray(parsedKey[0])) {
            res = processKeys(parsedKey, res)
        }

        const [subKey, value] = parsedKey
        res = { ...res, [subKey]: value }
    })

    return res
}

const preparePropertiesListByTemplate = (wigProperties, template) => {
    wigProperties = provideTopTapeProperty(wigProperties)

    return propertiesTemplates[template]
        .map((field) => {
            return {
                label: field.label,
                value: wigProperties[field.key],
                key: field.key,
            }
        })
        .filter(({ value, key }) => {
            const getProperty = (propertyKey) => {
                const [property] = JSON.parse(wigProperties[propertyKey])
                return Array.isArray(property) ? property[0] : property
            }

            const isMatching = (propertyKey) =>
                getProperty(propertyKey) === key || !!value

            if (template === 'topTape') {
                return isMatching('topType')
            }

            if (template === 'front') {
                return isMatching('front')
            }

            return !!value
        })
}

export default preparePropertiesListByTemplate
